import React from 'react';
import {
    Grid,
    Card,
    CardContent,
    Typography,
    useTheme,
} from '@mui/material';
import { MerchantLocationMap } from './LocationMapComponents.js';

const MerchantViewCard = ({ merchant }) => {
    const theme = useTheme();

    return (
        <Grid item xs={12} md={6}>
            <Card variant="outlined" sx={{ height: '100%' }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Merchant Information
                    </Typography>

                    {merchant.merchantName && merchant.merchantName !== 'Unknown Merchant' && (
                        <>
                            <Typography variant="subtitle2" color="text.secondary">
                                Name
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                {merchant.merchantName}
                            </Typography>
                        </>
                    )}

                    {merchant.merchantWebsite && (
                        <>
                            <Typography variant="subtitle2" color="text.secondary">
                                Website
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                <a
                                    href={merchant.merchantWebsite}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: theme.palette.primary.main }}
                                >
                                    {merchant.merchantWebsite}
                                </a>
                            </Typography>
                        </>
                    )}

                    {merchant.merchantPhone && (
                        <>
                            <Typography variant="subtitle2" color="text.secondary">
                                Phone
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                {merchant.merchantPhone}
                            </Typography>
                        </>
                    )}

                    {(merchant.merchantStreetAddress ||
                        merchant.merchantCity ||
                        merchant.merchantState ||
                        merchant.merchantZip) && merchant.merchantState !== "Unknown Location" && (
                            <>
                                <Typography variant="subtitle2" color="text.secondary">
                                    Address
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    {merchant.merchantStreetAddress && (
                                        <>
                                            {merchant.merchantStreetAddress}<br />
                                        </>
                                    )}
                                    {merchant.merchantCity }
                                    {merchant.merchantCity && merchant.merchantState && <>, </>}
                                    {merchant.merchantState }
                                    {merchant.merchantZip && (
                                        <>, {merchant.merchantZip}</>
                                    )}
                                </Typography>
                            </>
                        )}

                    {/* Merchant Location Map - only when merchant has geocode data */}
                    {merchant.hasMerchantMapData() && (
                        <>
                            <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{ mt: 2 }}>
                                Location Map
                            </Typography>
                            <MerchantLocationMap
                                merchantName={merchant.merchantName}
                                merchantGeocode={merchant.merchantGeocode}
                            />
                        </>
                    )}
                </CardContent>
            </Card>
        </Grid>
    );
};

export default MerchantViewCard;
